import React from 'react';
import PropTypes from 'prop-types';
import { useConnect, UseQueryConnect } from '@lore/query-connect';
import { PayloadStates } from '@lore/utils';
import Loader from '../../../components/Loader';
import Avatar from '../../../components/Avatar';
import useDialogLauncher from '../../../dialogs-routable/_hooks/useDialogLauncher';
import { DialogManager } from '../../../dialogs_new/DialogManager';

Invitations.propTypes = {
  event: PropTypes.object.isRequired
};

export default function Invitations(props) {
  const { event } = props;

  const MAX_CONVERSATIONS = 7;

  const launch = useDialogLauncher();

  function onClick(user) {
    launch(DialogManager.User.Config(user.id));
  }

  const responses = [
    'Yes',
    'Maybe',
    // 'No',
    // 'Pending'
  ];

  const invitations = useConnect('invitation.find', {
    where: {
      eager: {
        $where: {
          eventId: event.id,
          response: {
            $in: responses
          }
        }
      }
    }
  });

  if (invitations.state === PayloadStates.FETCHING) {
    return (
      <Loader/>
    );
  }

  function Circle(props) {
    return (
      <div className="h-8 w-8 bg-cs-orange-200 rounded-full text-cs-gray-900 flex items-center text-sm justify-center">
        {props.children}
      </div>
    );
  }

  if (invitations.data.length > 0) {
    return (
      <div className="flex space-x-2">
        {invitations.data.slice(0,MAX_CONVERSATIONS).map(function(invitation, index) {
          return (
            <UseQueryConnect key={index} _key="user.byId" params={{ id: invitation.data.userId }}>
              {function(user) {
                return (
                  <Avatar
                    key={index}
                    size={8}
                    src={user.data.avatarUrl}
                    tooltip={`${user.data.firstName} ${user.data.lastName}`}
                    onClick={() => onClick(user)}
                  />
                );
              }}
            </UseQueryConnect>
          );
        })}
        {invitations.data.slice(MAX_CONVERSATIONS).length > 0 && (
          <Circle>
            +{invitations.data.slice(MAX_CONVERSATIONS).length}
          </Circle>
        )}
      </div>
    );
  }

  return null;
}
